// src/api.js
import {
  getCategoriesUrl,
  getNewsPageUrl,
  getStoryUrl,
  getLastUpdatedUrl,
  getHashtagUrl,
} from "./config";

async function handleJsonFetch(url) {
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) {
    const error = new Error(`HTTP ${res.status}`);
    error.status = res.status;
    throw error;
  }
  return res.json();
}

export async function fetchCategories() {
  return handleJsonFetch(getCategoriesUrl());
}

/**
 * ✅ NEW paging:
 * fetchNewsPage(category, page="start.json")
 * returns: { stories:[], next:"", last_updated:null }
 */
export async function fetchNewsPage(category, page = "start.json") {
  const url = getNewsPageUrl(category, page);
  const raw = await handleJsonFetch(url);

  // support old array format just in case
  if (Array.isArray(raw)) {
    return { stories: raw, next: "", last_updated: null };
  }

  return {
    stories: raw.stories || raw.items || [],
    next: raw.next || raw.next_ref || raw.nextRef || "",
    last_updated: raw.last_updated || raw.lastUpdated || null,
  };
}

export async function fetchStory(slug) {
  return handleJsonFetch(getStoryUrl(slug));
}

// ✅ NEW: last updated poller endpoint
export async function fetchLastUpdated() {
  return handleJsonFetch(getLastUpdatedUrl());
}

export async function fetchHashtagNews(tag) {
  const url = getHashtagUrl(tag.toLowerCase());
  const raw = await handleJsonFetch(url);

  // support old array format just in case
  if (Array.isArray(raw)) {
    return { stories: raw, next: "", last_updated: null };
  }
 
  return {
    stories: raw.stories || raw.items || [],
    next: raw.next || raw.next_ref || raw.nextRef || "",
    last_updated: raw.last_updated || raw.lastUpdated || null,
  };
}